/*
 * Copyright (c) webzuu Michał Stambulski 2018.
 */

import update from 'immutability-helper';

export default function reorder(data, dragIndex, hoverIndex, ids) {

  if (ids) {
    dragIndex = data.indexOf(dragIndex);
    hoverIndex = data.indexOf(hoverIndex);
  }

  const draggedItem = data[dragIndex];
  if (!draggedItem) return data;

  let newData = data.slice();

  //newData[dragIndex] = { ...newData[dragIndex] };
  //newData[hoverIndex] = { ...newData[hoverIndex] };

  return update(newData, {
    $splice: [[dragIndex, 1], [hoverIndex, 0, draggedItem]]
  });
}

export const moveAtPosition = (data, id, index) => {
  let newData = data ? data.slice() : [];

  return update(newData, {
    $splice: [[index, 0, id]]
  })
};
